// extracted by mini-css-extract-plugin
module.exports = {"container":"TaskList_container__2R91U"};